<div class="role-switcher" *ngIf="showCanSwitch">

  <button
    type="button"
    class="role-switcher-trigger"
    (click)="toggleDropdown()"
    [disabled]="isSwitching"
  >
    <fa-icon [icon]="icons.user" class="role-switcher-icon"></fa-icon>
    <span class="role-switcher-label">{{ roleLabel(currentRole) }}</span>
    <span *ngIf="isSwitching" class="role-switcher-spinner" role="status"></span>
    <fa-icon *ngIf="!isSwitching" [icon]="icons.chevronDown" class="role-switcher-chevron"
      [class.role-switcher-chevron--open]="dropdownOpen"></fa-icon>
  </button>

  <div *ngIf="dropdownOpen" class="role-switcher-menu">
    <button
      type="button"
      class="role-switcher-item"
      *ngFor="let role of switchableRoles"
      (click)="onSwitchRole(role)"
    >
      Switch to {{ roleLabel(role) }}
    </button>
  </div>

  <div *ngIf="switchError" class="role-switcher-error">
    {{ switchError }}
  </div>
</div>